import { carrierToAirline } from '@/lib/flight-utils'
import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { ApplicationState } from '@/redux/stores/types'
import { FlightBookingSegment } from '@/types/flights/booking'
import { Airline } from '@/types/flights/common'

import { IAction } from '../actions/action-helpers'
import { AirlinesTypes, ItineraryTypes } from '../actions/actions.types'

export type AirlinesState = ApplicationState['airlines']

function airlinesReducer(state: AirlinesState = new ImmutableMap<string, Airline>(), action: IAction): AirlinesState {
	switch (action.type) {
		case AirlinesTypes.SetAirlines:
			return (action.payload ?? []).reduce(
				(newState: AirlinesState, airline: Airline) => newState.set(airline.iata, airline),
				state,
			)
		case ItineraryTypes.GetItinerary.SUCCESS:
			return action.payload.flights_bookings.reduce(
				(state0: AirlinesState, booking: FlightBookingSegment) =>
					booking.flights.reduce(
						(state1: AirlinesState, flight) =>
							flight.segments.reduce((state2: AirlinesState, seg) => {
								const newState = state2.set(seg.carrier.code, carrierToAirline(seg.carrier))
								return seg.operating_carrier
									? newState.set(seg.operating_carrier.code, carrierToAirline(seg.operating_carrier))
									: newState
							}, state1),
						state0,
					),
				state,
			)
		default:
			return state
	}
}

export default airlinesReducer
